import { freeSet } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Action, Fab } from "react-tiny-fab";
import "react-tiny-fab/dist/styles.css";
import { filterTicketType } from "src/actions/filterActions";
const mainButtonStyles = {
  backgroundColor: "#E74C3C",
  borderColor: "transparent",
};
export default function FloatingButton(props) {
  const dispatch = useDispatch();
  const { type } = useSelector((state) => state.filter);

  const [icon, setIcon] = useState();

  useEffect(() => {
    setIcon(
      type === 1 ? (
        <CIcon content={freeSet.cilMedicalCross} size="lg" />
      ) : type === 2 ? (
        <CIcon content={freeSet.cilCarAlt} size="lg" />
      ) : (
        <CIcon content={freeSet.cilSettings} size="lg" />
      )
    );
  }, [type]);
  return (
    <Fab
      mainButtonStyles={mainButtonStyles}
      icon={icon}
      alwaysShowTitle={true}
      event={"hover"}
      // onClick={(e) => console.log("test", e)}
    >
      <Action
        text="CITY ORDINANCE"
        onClick={() => {
          setIcon();
          dispatch(filterTicketType({ type: 1 }));
          setIcon(<CIcon content={freeSet.cilMedicalCross} size="lg" />);
        }}
        style={{
          backgroundColor: "#105272",
        }}
      >
        <CIcon content={freeSet.cilMedicalCross} size="lg" />
      </Action>
      <Action
        text="TRAFFIC"
        onClick={() => {
          setIcon();
          dispatch(filterTicketType({ type: 2 }));
          setIcon(<CIcon content={freeSet.cilCarAlt} size="lg" />);
        }}
        style={{
          backgroundColor: "#105272",
        }}
      >
        <CIcon content={freeSet.cilCarAlt} size="lg" />
      </Action>
      <Action
        text="ALL"
        onClick={() => {
          setIcon();
          dispatch(filterTicketType({ type: undefined }));
          setIcon(<CIcon content={freeSet.cilClearAll} size="lg" />);
        }}
        style={{
          backgroundColor: "#105272",
        }}
      >
        <CIcon content={freeSet.cilClearAll} size="lg" />
      </Action>
    </Fab>
  );
}
